import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import Footer from './Footer';
import './ErrorState.css';

const ErrorState = () => (
  <div className="not-found-page">
    <div className="not-found-main">
      <div className="not-found-card">
        <AlertTriangle className="not-found-icon" aria-hidden="true" size={48} />
        <h1>Something went wrong</h1>
        <p className="not-found-message">
          Sorry about that — something broke while loading this page. Trying
          again usually fixes it; if it keeps happening, reach out and we'll
          take a look.
        </p>

        <button type="button" className="not-found-primary-btn" onClick={() => window.location.reload()}>
          Try again
        </button>

        <nav className="not-found-links" aria-label="Helpful links">
          <ul>
            <li>
              <Link to="/">Back to homepage</Link>
            </li>
            <li>
              <a href="#site-footer">Contact</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <Footer />
  </div>
);

export default ErrorState;
